import {
  Box,
  ExternalLink,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@alice-financial/pretext-ui'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined'
import * as React from 'react'
import { BillingInfo } from '../../billing/BillingHealthcheck'
import { useOrg } from '../../organization/useOrg'

export const BillingStepTitle = 'Billing'

export const BillingDescription = () => (
  <Typography variant="body2" color="text.secondary">
    Connect your payment method for Alice services
  </Typography>
)

// Wrapper component that uses the core billing components
export const BillingComponent = () => {
  const org = useOrg()

  if (!org) return null

  return (
    <>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Connect a payment method to cover Alice service fees and employee benefits.
      </Typography>
      <BillingInfo org={org} />
      {/* Add pay groups alert if needed */}
      {!org.billing?.hasUnifiedBilling && !org.isOnboarded && org.employers.length === 0 && (
        <Box mt={2} p={2} sx={{ backgroundColor: 'info.light', borderRadius: 1 }}>
          <Typography variant="body2">
            <strong>Enter your first pay group</strong>
            <br />
            You can create new pay groups and assign them to locations in the Work Locations step.
          </Typography>
        </Box>
      )}
    </>
  )
}

export const BillingInstructions = () => (
  <>
    <Typography variant="body2" color="text.secondary" gutterBottom>
      Alice will bill you an amount equal to your payroll tax savings on employee elections each pay period.
    </Typography>

    <Typography variant="body2" color="text.secondary" gutterBottom>
      Check out our{' '}
      <ExternalLink
        href="https://help.thisisalice.com/article/70-for-your-finance-team-how-alice-works-for-employers"
        target="_blank"
      >
        guide for your finance team
      </ExternalLink>{' '}
      for more detail.
    </Typography>
    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
      Requirements
    </Typography>
    <List dense>
      <ListItem disableGutters>
        <ListItemIcon>
          <CheckCircleOutlineIcon fontSize="small" color="primary" />
        </ListItemIcon>
        <ListItemText primary="Bank account and routing number, credit card, or bank login information" />
      </ListItem>
    </List>

    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
      Key Info
    </Typography>
    <List dense>
      <ListItem disableGutters>
        <ListItemIcon sx={{ minWidth: 32 }}>
          <LightbulbOutlinedIcon fontSize="small" color="warning" />
        </ListItemIcon>
        <ListItemText primary="If using a bank account, make sure ACH transfers will not be blocked from our accounts" />
      </ListItem>
    </List>
  </>
)
